import { IPaymentSettingsItem } from "web/types/Payment";

import { BANK_PAYMENTS_TYPE } from "../consts";

const sortRuleBankFrequency = (
  firstPayment: IPaymentSettingsItem,
  secondPayment: IPaymentSettingsItem,
  context: { productCountByBankId: Record<string, number> }
) => {
  const { productCountByBankId } = context;

  if (
    firstPayment.type !== BANK_PAYMENTS_TYPE ||
    secondPayment.type !== BANK_PAYMENTS_TYPE
  ) {
    return 0;
  }

  const firstCount = productCountByBankId?.[firstPayment.code] ?? Infinity;

  const secondCount = productCountByBankId?.[secondPayment.code] ?? Infinity;

  if (firstCount < secondCount) {
    return -1;
  }

  if (firstCount > secondCount) {
    return 1;
  }

  return 0;
};

export default sortRuleBankFrequency;
